// Small helpers for reconciling optimistic refresh state with server-confirmed state.
export const getEffectiveRefreshStatus = ({ refreshStatus, optimisticRefreshStatus }) => {
  if (!optimisticRefreshStatus) return refreshStatus;
  if (refreshStatus?.refreshId && refreshStatus.refreshId === optimisticRefreshStatus.refreshId) {
    return refreshStatus;
  }
  return optimisticRefreshStatus;
};

export const isTerminalRefreshStatus = (status) => status === 'completed' || status === 'failed';
